import { useProductStoreContext } from "@project/emerge";
import { Edges } from "@react-three/drei";
import type * as THREE from "three";

/**
 * Dihedral angle above which an edge is drawn, in degrees.
 *
 * Above the 45° of a chamfer: every edge is now two chamfer edges a few tenths
 * of a millimetre apart, and a lower threshold draws both, so the outline reads
 * as doubled and fuzzy. This keeps the real 90° corners and drops the chamfer
 * flanks and the segments of a rounded profile corner.
 *
 * Shared so parts that build their own `EdgesGeometry` (see
 * `AngleSectionRenderer`) cannot drift back to three's 1° default, which draws
 * both flanks of every chamfer.
 */
export const PART_EDGE_THRESHOLD_DEG = 50;

/**
 * @param geometry Outlined instead of the mesh's own, for parts whose surface
 *   detail is geometry rather than texture — see `createSpikedPadOutline`,
 *   where the mesh's own ridges would all clear the threshold and draw.
 */
export const PartEdges = ({
  geometry,
}: {
  geometry?: THREE.BufferGeometry;
}) => {
  const useProductStore = useProductStoreContext();
  const showEdges = useProductStore((state) => state.showEdges);
  if (!showEdges) return null;
  return (
    <Edges
      color="black"
      geometry={geometry}
      threshold={PART_EDGE_THRESHOLD_DEG}
    />
  );
};
